import { render, staticRenderFns } from "./kitItem.vue?vue&type=template&id=0902aca5&"
import script from "./kitItem.vue?vue&type=script&lang=js&"
export * from "./kitItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports